var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeltTipPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 189.624 189.624",
    xmlSpace: "preserve",
    transform: "matrix(1, 0, 0, -1, 0, 0)rotate(-45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.16,51.035l-4.883-4.883l3.456-3.456c0.938-0.938,1.464-2.209,1.464-3.535s-0.527-2.598-1.464-3.535L156.681,5.574 c-1.953-1.953-5.118-1.953-7.071,0l-3.455,3.455l-5.573-5.573c-1.922-1.924-5.028-1.958-6.992-0.078L23.28,108.901 c-0.972,0.931-1.529,2.213-1.543,3.558c-0.015,1.346,0.513,2.64,1.464,3.591l3.276,3.276l-6.831,6.831 c-1.046,1.046-1.575,2.504-1.445,3.978c0.011,0.128,1.114,12.85-0.333,20.565c-1.333,7.114-7.667,14.959-7.727,15.032 c-1.627,1.988-1.482,4.886,0.334,6.702l0.177,0.177l-9.955,9.955c-1.382,1.382-0.594,3.749,1.341,4.027l6.634,0.952 c2.684,0.385,5.396-0.486,7.355-2.361l3.732-3.573c0.875,0.646,1.909,0.99,2.956,0.99c1.117,0,2.237-0.372,3.162-1.124 c0.079-0.064,7.923-6.397,15.038-7.731c2.594-0.486,6.215-0.743,10.47-0.743c5.395,0,10.048,0.407,10.094,0.411 c1.484,0.126,2.932-0.397,3.979-1.445l6.831-6.831l3.276,3.276c0.938,0.938,2.21,1.465,3.536,1.465c0.019,0,0.037,0,0.056,0 c1.345-0.016,2.627-0.571,3.558-1.544L188.237,58.026C190.116,56.062,190.081,52.957,188.16,51.035z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeltTipPen);
export default __webpack_public_path__ + "static/media/felt-tip-pen.2ba3c9b8d044f29f5b64ebf2f69ad675.svg";
export { ForwardRef as ReactComponent };